module.exports = __webpack_public_path__ + "static/media/sound_12.97596095.mp3";